import { createContext } from 'react';

export interface LoaderContextType {
  showLoader: () => void;
  hideLoader: () => void;
  isLoading: boolean;
  activeRequests: number;
}

export const LoaderContext = createContext<LoaderContextType | undefined>(undefined);
